import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import api, { fileUrl } from "@/lib/api";
import { usePlayer } from "@/context/PlayerContext";
import { Button } from "@/components/ui/button";
import { Play, Pause, ArrowLeft, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function TrackPage() {
  const { id } = useParams();
  const nav = useNavigate();
  const [track, setTrack] = useState(null);
  const { playTrack, current, isPlaying } = usePlayer();
  const { isPremium } = useAuth();

  useEffect(() => {
    api.get(`/tracks/${id}`).then((r) => setTrack(r.data)).catch(() => setTrack(false));
  }, [id]);

  if (track === null) return <div className="p-12 text-muted-foreground overline text-sm">LOADING...</div>;
  if (track === false) return <div className="p-12 text-muted-foreground">Track not found.</div>;

  const cover = fileUrl(track.cover_file_id);
  const active = current && current.id === track.id;

  return (
    <div>
      <button data-testid="back-btn" onClick={() => nav(-1)} className="flex items-center gap-2 px-6 md:px-12 pt-8 text-muted-foreground hover:text-white transition-colors text-xs overline">
        <ArrowLeft size={16} /> Back
      </button>
      <section className="px-6 md:px-12 py-8 flex flex-col md:flex-row gap-8 items-start">
        <div className="w-full max-w-xs aspect-square bg-secondary border border-border block-shadow overflow-hidden shrink-0">
          {cover ? <img src={cover} alt={track.title} className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center font-display text-6xl text-white/20">{track.title?.[0]}</div>}
        </div>
        <div className="flex-1">
          <div className="overline text-xs text-accent mb-2">Track</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[0.95] mb-3">{track.title}</h1>
          <div className="text-muted-foreground mb-1">{track.artist}</div>
          {track.album_title && track.album_id && (
            <Link to={`/album/${track.album_id}`} data-testid="track-album-link" className="text-sm text-primary hover:underline">From: {track.album_title}</Link>
          )}
          <div className="text-sm text-muted-foreground mb-6 mt-1">{track.plays || 0} plays{track.genre ? ` · ${track.genre}` : ""}</div>
          <div className="flex items-center gap-3">
            <Button data-testid="track-play" onClick={() => playTrack(track, [track])} className="bg-primary hover:bg-white hover:text-primary rounded-none font-bold overline text-sm h-12 px-8">
              {active && isPlaying ? <><Pause size={18} className="mr-2" /> Pause</> : <><Play size={18} className="mr-2" /> Play</>}
            </Button>
            {!isPremium && (
              <span className="text-xs overline text-accent flex items-center gap-1"><Lock size={12} /> 25s preview</span>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
